import { mapState } from 'vuex';

// Services
import { AirtableService } from '@/services/airtable.service';
import { PrescriptionService } from '@/services/prescription.service';
import { formatPrescriptionDosage } from '@/utils/prescriptionDosage';

// Components
import CardAirtableOrder from '@/components/patients/partials/CardAirtableOrder';
import AirtableAddressDialog from '@/components/patients/AirtableAddressDialog';
import AirtableShippingDialog from '@/components/patients/AirtableShippingDialog';
import AirtableOrderSkeleton from '@/components/infoview/AirtableOrderSkeleton';
export default {
  components: {
    CardAirtableOrder,
    AirtableAddressDialog,
    AirtableShippingDialog,
    AirtableOrderSkeleton
  },
  props: {
    patientData: {
      type: Object,
      default() {
        return {
          id: '',
          firstname: '',
          lastname: ''
        };
      }
    }
  },
  data() {
    return {
      airtableOrders: [],
      selectedAirtableOrder: {},
      loading: false
    };
  },
  computed: {
    ...mapState('infoview', {
      isOrderManagerOpen: 'displayAirtable',
      selectedPrescription: 'airtableDisplayPrescription'
    })
  },
  watch: {
    async isOrderManagerOpen(show) {
      if (show) {
        await this.getAirtableOrders(this.selectedPrescription.id);
      } else {
        this.airtableOrders = [];
      }
    },
    async selectedPrescription(val) {
      if (val) {
        this.airtableOrders = [];
        await this.getAirtableOrders(val.id);
      }
    }
  },
  methods: {
    formatDosage(medicinename, dosage) {
      return formatPrescriptionDosage(medicinename, dosage);
    },
    async fetchAirtableOrders(prescriptionId) {
      const {
        data
      } = await AirtableService.getAirtableOrders(prescriptionId);
      this.airtableOrders = data;
      this.airtableOrders.__ob__.dep.notify();
    },
    async fetchPrescriptions() {
      const {
        data
      } = await PrescriptionService.getPrescription(this.patientData.id);
      this.prescriptionData = data;
      this.prescriptionData.__ob__.dep.notify();
      this.$emit('refresh-prescriptions');
    },
    async getAirtableOrders(prescriptionId, refetch = false) {
      if (!prescriptionId) {
        return;
      }
      this.loading = true;
      await Promise.allSettled([this.fetchAirtableOrders(prescriptionId), refetch && this.fetchPrescriptions()]);
      this.loading = false;
    },
    close() {
      this.$store.dispatch('infoview/closeAirtableDisplay');
    },
    onAirtableAddressUpdate(order) {
      this.$refs.AirtableAddressDialog.showDialog = true;
      this.selectedAirtableOrder = order;
    },
    onAirtableShippingUpdate(order) {
      this.$refs.AirtableShippingDialog.showDialog = true;
      this.selectedAirtableOrder = order;
    },
    updateSelectedAirtableOrder(newOrder) {
      const index = this.airtableOrders.findIndex(order => order.id === newOrder.id);
      if (index !== -1) {
        this.airtableOrders[index] = newOrder;
      }
      this.airtableOrders.__ob__.dep.notify();
    }
  }
};